export const REVIEW_TOP_UP_CATEGORIES = [
  {
    key: "microbiology",
    name: "Microbiology",
    iconClass: "ReviewOneTimeTopUpModal__CategoryIcon--microbiology",
    items: [
      { key: "microbiology-basic", name: "Basic", quantity: 500, rate: 1 },
      { key: "microbiology-advanced", name: "Advanced", quantity: 500, rate: 1.5 },
      { key: "microbiology-specialty", name: "Specialty", quantity: 500, rate: 2 },
    ],
  },
  {
    key: "chemistry",
    name: "Chemistry",
    iconClass: "ReviewOneTimeTopUpModal__CategoryIcon--chemistry",
    items: [
      { key: "chemistry-basic", name: "Basic", quantity: 100, rate: 1 },
      { key: "chemistry-advanced", name: "Advanced", quantity: 200, rate: 1.5 },
      { key: "chemistry-specialty", name: "Specialty", quantity: 200, rate: 2 },
    ],
  },
];
